.input-validation-message {
  font-family: var(--asset-fonts-body);
}
